/* eslint-disable */
/**
 * Apply global form class
 */
const form = document.querySelector('form');

if (form && !form.classList.contains('m-form')) {
  form.classList.add('m-form');
}

/**
 * WordPress forms
 */
const loginForm = document.querySelector('#loginform');

if (loginForm) {
  const submit = document.querySelector('.login-submit input');
  submit.className = 'a-btn a-btn--accent a-btn--wide';
}

/**
 * ACF form customisations
 */
const acfBtn = document.querySelector('.acf-form-submit input');

if (acfBtn) {
  acfBtn.className = 'a-btn a-btn--accent a-btn--wide';

  const cancelBtn = document.createElement('input');
  cancelBtn.className = 'a-btn a-btn--text';
  cancelBtn.value = 'Cancel';
  cancelBtn.type = 'reset';

  acfBtn.insertAdjacentElement('afterend', cancelBtn);
}

/**
 * Apply onClick state to Gravity Form buttons
 */
const gravityForm = document.querySelector('.gform_wrapper form');

function gravitySubmit(event) {
  let submitTimer;

  event.preventDefault();
  submitTimer = setTimeout(() => {
    this.submit();
  }, 1000);

  const button = document.querySelector('.gform_button');
  const text = document.querySelector('.gform_button span');

  button.disabled = true;
  text.innerHTML = 'Submitting...';
}

if (gravityForm) {
  gravityForm.addEventListener('submit', gravitySubmit);
}

/**
 * Apply onClick state to edit profile button
 * - Requires duplicate code because of form markup
 */
const editProfileForm = document.querySelector('.t-profile__content form');

function editProfileSubmit(event) {
  let submitTimer;

  event.preventDefault();
  submitTimer = setTimeout(() => {
    this.submit();
  }, 1000);

  const button = document.querySelector('input[type="submit"]');

  button.disabled = true;
  button.value = 'Saving changes...';
}

if (editProfileForm) {
  editProfileForm.addEventListener('submit', editProfileSubmit);
}

/**
 * Apply notice classes to Gravity Forms validations
 */

const gfError = document.querySelector('.gform_submission_error');

if (gfError) {
  gfError.classList.add('u-notice', 'u-notice-error');
}

/**
 * Create material style field labels
 */
const formFieldClass = 'm-form__field';
const materialLabelModifier = 'm-form__field--label-floating';
const userFlowForm = document.querySelector('.t-user-flow__form');

if (userFlowForm) {
  const email = document.querySelector('.login-email');
  const password = document.querySelector('.login-password');
  const username = document.querySelector('.login-username');

  if (email) {
    email.classList.add(formFieldClass, materialLabelModifier);
  }

  if (password) {
    password.classList.add(formFieldClass, materialLabelModifier);
  }

  if (username) {
    username.classList.add(formFieldClass, materialLabelModifier);
  }
}

/**
 * Toggle active states on material style field labels
 */
function handleMaterialLabels(el) {
  // get input & label
  let field;
  const label = el.querySelector('label');
  const input = el.querySelector('input');
  const textarea = el.querySelector('textarea');

  if (input) {
    field = input;
  } else {
    field = textarea;
  }

  // apply class to populated fields if pre-populated or after submission error
  if (field.value) {
    label.classList.add('is-active');
  }

  // get focus event and apply class
  field.addEventListener('focus', () => {
    label.classList.add('is-active');
  });

  // get focusout event and remove class if field has not been populated
  field.addEventListener('focusout', () => {
    if (!field.value) {
      label.classList.remove('is-active');
    }
  });
}

/**
 * Get and handle all fields with material label class
 */
const materialLabels = document.querySelectorAll(`.${materialLabelModifier}`);

if (materialLabels) {
  materialLabels.forEach(handleMaterialLabels);
}

/**
 * Change button text on event pages
 */
const eventForm = document.querySelector('.m-form--event');

if (eventForm) {
  const eventPrice = document.querySelector('.event-price').textContent;
  const gravityPriceField = document.querySelector('.ginput_product_price');
  const btn = eventForm.querySelector('.gform_button span');
  const btnText = `Pay ${eventPrice} now`;

  if (!eventPrice.includes('Free')) {
    btn.textContent = btnText;
  }

  if (gravityPriceField) {
    const gravityPriceVal = eventPrice;
    gravityPriceField.value = gravityPriceVal;
  }
}

/**
 * Handle variable ticket price form
 */
const tieredEventForm = document.querySelector('.m-form--tiered-event');

if (tieredEventForm) {
  const ticketPrices = Array.from(
    tieredEventForm.querySelectorAll('.gfield .gchoice input'),
  ).map((input) => parseFloat(input.value));
  const eventPrice = document.querySelector('.event-price-variable');

  const sortedPrices = ticketPrices.sort((a, b) => a - b);

  eventPrice.innerHTML = `£${sortedPrices[0].toFixed(2)} - £${sortedPrices[sortedPrices.length - 1].toFixed(2)}`;

  const gravityPriceField = document.querySelector('.ginput_product_price');
  const radioInputs = document.querySelectorAll(
    '.ginput_container_radio input',
  );
  const btn = tieredEventForm.querySelector('.gform_button span');

  radioInputs.forEach((radioInput) => {
    radioInput.addEventListener('change', function () {
      if (this.value != 0.00) {
        const selectedValue = parseFloat(this.value).toFixed(2);
        gravityPriceField.value = selectedValue;
        btn.textContent = `Pay £${selectedValue} now`;
      } else {
        gravityPriceField.value = 0.00;
        btn.textContent = 'Book now';
      }
    });
  });
}
